import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import CityNameCMSModel from '@/visa-application/models/CityNameCMSModel';

export default class CityCMSModel implements CMSModel {
  city_name_translation: CityNameCMSModel[] = [];

  map(obj: any): void {
    this.city_name_translation = _.get(obj, 'translation[0].city_name_translation', []);
  }
}
